<template>
    <div id="stages-small" class="py-3 m-0 bg-white" v-show="currentSection > 0">
      <div class="container">
        <h3 class="text-blue2 text-center mb-0">{{ sections[currentSection].name | kebabToTitleCase }}</h3>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'enquiry-form-section-breadcrumb-mobile',
  props: {
    currentSection: {},
    currentQuestionNumber: {}
  },

  filters: {
    kebabToTitleCase: function (value) {
      if (!value) return ''
      return value.split('-').map(function (item) {
        return item.charAt(0).toUpperCase() + item.substring(1)
      }).join(' ')
    }
  },

  computed: {
    ...mapGetters({
      questions: 'form/questions',
      answers: 'form/answers',
      sections: 'form/sections'
    }),

    numberOfQuestionsInSection: function () {
      return this.questions.filter(question => {
        return question.question_section_id === this.currentSection
      }).length
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/enquiry-form-section-breadcrumb-mobile.vue